export class AccountApi {
  constructor(client) {
    this.client = client;
  }
  getPublicToken(username, password) {
    return this.client.getPublicToken(username, password);
  }
  refreshToken() {
    return this.client.refreshToken();
  }
  logout() {
    return this.client.logout();
  }
  useLanguage(language) {
    this.client.useLanguage(language);
  }
  usePublicToken(accessToken) {
    this.client.usePublicToken(accessToken);
  }
  useAdminToken(accessToken) {
    this.client.useAdminToken(accessToken);
  }
  module(path) {
    return this.client.getModuleWrapper(`/${path}`);
  }
  resource(path) {
    return this.client.getResourceWrapper(`/${path}`);
  }
  collection(path) {
    return this.client.getCollectionWrapper(`/${path}`);
  }
}